<a *ngIf="!hrefLink && routerLink" [routerLink]="routerLink" [queryParams]="utmParams"
   class="news-link">
  <ng-template [ngTemplateOutlet]="linkContent"></ng-template>
</a>
<a *ngIf="hrefLink" [target]="linkTarget" [href]="hrefLink"
   class="news-link">
  <ng-template [ngTemplateOutlet]="linkContent"></ng-template>
</a>
<div *ngIf="!hrefLink && !routerLink" style="width: 100%">
  <ng-template [ngTemplateOutlet]="linkContent"></ng-template>
</div>
<ng-template #linkContent>
  <ng-content></ng-content>
</ng-template>
